/** Класс меню в навигации хедера и подвала. */
class ToggleSublist {
    /**
     * Конструктор класса.
     *
     * @param {HTMLElement} el Элемент.
     */
    constructor(el) {
        this.el = el;
        this.submenu = this.el.querySelector(".js-submenu");

        this.bindEventListeners();
    }
    /**
     * Отслеживание событий.
     *
     * @returns {void}
     */
    bindEventListeners() {
        this.el.addEventListener("click", (e) => {
            if (e.target.classList.contains("js-submenu-link") || e.target.closest(".js-submenu-link")) {
                e.stopPropagation();
                e.preventDefault();
            }

            this.toggleVisibilitySubmenu();
        })

        document.addEventListener("click", (e) => {
            const clickOutsideMenu = !e.target.classList.contains("js-toggle-submenu") ||
                !e.target.closest(".js-toggle-submenu");

            if (clickOutsideMenu) {
                this.el.classList.remove("is-open");
                this.submenu.classList.remove("is-open");
            }
        })
    }

    /**
     * Переключение видимости подменю.
     *
     * @returns {void}
     */
    toggleVisibilitySubmenu() {
        this.el.classList.toggle("is-open");
        this.submenu.classList.toggle("is-open");
    }
}

document.querySelectorAll(".js-toggle-submenu").forEach((el) => new ToggleSublist(el));
